/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_Import_Reason_DuplicateInputs */



/**
* | output |
* | --- |
* | "duplicate of an earlier row" |
*
* @param {Csv_Import_Reason_DuplicateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const csv_import_reason_duplicate = /** @type {((inputs?: Csv_Import_Reason_DuplicateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_Import_Reason_DuplicateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("doublon d'une ligne précédente")
	if (locale === "es") return /** @type {LocalizedString} */ ("duplicado de una fila anterior")
	if (locale === "pt") return /** @type {LocalizedString} */ ("duplicado de uma linha anterior")
	if (locale === "it") return /** @type {LocalizedString} */ ("duplicato di una riga precedente")
	return /** @type {LocalizedString} */ ("duplicate of an earlier row")
});